function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "luminosity-noclip",
  x: 162,
  y: 162,
  width: 88,
  height: 54,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  result: "bg"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "bg"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask",
  x: 162,
  y: 162,
  width: 88,
  height: 54,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#luminosity-noclip)"
}, /*#__PURE__*/React.createElement("image", {
  width: 88,
  height: 54,
  transform: "translate(162 162)",
  xlinkHref: "data:image/png;base64,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"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 285.42,
  y1: 156.12,
  x2: 252.94,
  y2: 187.54,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8c6239"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 121.66,
  y1: 149.34,
  x2: 90.06,
  y2: 204.64,
  xlinkHref: "#linear-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "201-210");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M40.89,184.9,201.6,277.52a4.56,4.56,0,0,0,4.53,0l157.2-89.25a4.56,4.56,0,0,0,0-7.92L199.91,86.84a4.56,4.56,0,0,0-4.56,0L40.87,177A4.56,4.56,0,0,0,40.89,184.9Z",
  fill: "#ef8989"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M203.44,164.32l-16.36,9.91s-3.27.59-4-2.38S175.78,165.31,171,168s-.4,6.44,4.66,7,4.66,1.78,3.57,3.07-14.67,9-14.67,9l16.26,9.71s3,1.19,1.78,2.78-4.56-2.28-8.23,1.49,3.77,7.14,8.23,6.54,4.76-2.38,4.76-3.77,1.29-2,2.58-1.39,19.63,10.61,19.63,10.61l15.27-9.22s-6.94.4-9.71-3.17-2-7.53,3.37-8.13,12.79,1.88,12.59,7.14l16.75-9-19.23-11.2s-2.78,8.23-13,6-6-9.48,7.06-9.88Z",
  fill: "#a35745"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M205.59,250.58l-125-72L201,108.28,328.1,181l-8,4.53.29.2.64.42,8.31-4.72.76-.43L201.21,107.27l-.25-.14L78.58,178.54l126.76,73,.25.14,7.33-4.16a9.89,9.89,0,0,1-.85-.67Z",
  fill: "#f2f2f2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M205.66,151l-16.36,9.91s-3.27.59-4-2.38S178,152,173.25,154.64s-.4,6.44,4.66,7,4.66,1.78,3.57,3.07-14.67,9-14.67,9l16.26,9.71s3,1.19,1.78,2.78-4.56-2.28-8.23,1.49,3.77,7.14,8.23,6.54,4.76-2.38,4.76-3.77,1.29-2,2.58-1.39,19.63,10.61,19.63,10.61l15.27-9.22s-6.94.4-9.71-3.17-2-7.53,3.37-8.13,12.79,1.88,12.59,7.14l16.75-9-19.23-11.2s-2.78,8.23-13,6-6-9.48,7.06-9.88Z",
  fill: "#e1a621"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M171.2,146.91v10.34s1.9,2.36,6.28,1.92,6.17-6.68,6.17-6.68",
  fill: "#e1a621"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M166.8,163.51v10.26l9.58,4.65-.67,1.7-.05,9.94s5,1.15,7.49,0,3.55-4.92,6.11-5.18,28.13,7.48,28.13,7.48l9.69-1.84V180.27s-13,6.16-17.48.11",
  fill: "#e1a621"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M250.07,177.34V167.08l-25.16-4.77V152.05s-8.18-.2-8.3-.16-11.21,2.82-6.1,9.39-3.11,12.51,4.29,13.7",
  fill: "#e1a621"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.36
}, /*#__PURE__*/React.createElement("path", {
  d: "M205.66,151l-16.36,9.91s-3.27.59-4-2.38S178,152,173.25,154.64s-.4,6.44,4.66,7,4.66,1.78,3.57,3.07-14.67,9-14.67,9l16.26,9.71s3,1.19,1.78,2.78-4.56-2.28-8.23,1.49,3.77,7.14,8.23,6.54,4.76-2.38,4.76-3.77,1.29-2,2.58-1.39,19.63,10.61,19.63,10.61l15.27-9.22s-6.94.4-9.71-3.17-2-7.53,3.37-8.13,12.79,1.88,12.59,7.14l16.75-9-19.23-11.2s-2.78,8.23-13,6-6-9.48,7.06-9.88Z",
  fill: "#00275e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M171.2,146.91v10.34s1.9,2.36,6.28,1.92,6.17-6.68,6.17-6.68",
  fill: "#00275e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.8,163.51v10.26l9.58,4.65-.67,1.7-.05,9.94s5,1.15,7.49,0,3.55-4.92,6.11-5.18,28.13,7.48,28.13,7.48l9.69-1.84V180.27s-13,6.16-17.48.11",
  fill: "#00275e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M250.07,177.34V167.08l-25.16-4.77V152.05s-8.18-.2-8.3-.16-11.21,2.82-6.1,9.39-3.11,12.51,4.29,13.7",
  fill: "#00275e"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M205.66,140.71l-16.36,9.91s-3.27.59-4-2.38-7.34-6.54-12.09-3.87-.4,6.44,4.66,7,4.66,1.78,3.57,3.07-14.67,9-14.67,9l16.26,9.71s3,1.19,1.78,2.78-4.56-2.28-8.23,1.49,3.77,7.14,8.23,6.54,4.76-2.38,4.76-3.77,1.29-2,2.58-1.39,19.63,10.61,19.63,10.61l15.27-9.22s-6.94.4-9.71-3.17-2-7.53,3.37-8.13,12.79,1.88,12.59,7.14l16.75-9-19.23-11.2s-2.78,8.23-13,6-6-9.48,7.06-9.88Z",
  fill: "#e1a621"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M277,163.17v3.62s1.55,4.25,10.72,4.25,10.59-4.64,10.59-4.64v-4.09",
  fill: "#653200"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M269.37,145.25a3.31,3.31,0,0,0-1.88,2.25c-.31,1.61,0,8.63,0,8.63s.34,8.74,20.2,8.74S307,155.06,307,155.06v-7.75a2.64,2.64,0,0,0-3.53-2.06",
  fill: "#e55757"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M270.28,148s-1.12-4.46-3.07-6.7-12.83-11.72-12.28-25.67c.53-13.18,6.33-26.2,18.73-32.08,24.54-11.63,50.19,8.15,46.55,34.87-1.91,14-13.17,21-14.35,24.2a20.91,20.91,0,0,0-1,4.81s-5,7.53-17.15,7.53S270.28,148,270.28,148Z",
  fill: "#ffae64"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M306.34,115.91c-.84-7.44-2.46-14.57-8.77-19.24C295,94.76,292.48,99.1,295,101c4.67,3.45,5.69,9.52,6.3,14.92C301.69,119.07,306.7,119.11,306.34,115.91Z",
  fill: "#fff",
  opacity: 0.88
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M302.92,121.5a2.54,2.54,0,0,0-2.5,2.5v.31a2.5,2.5,0,0,0,5,0V124A2.53,2.53,0,0,0,302.92,121.5Z",
  fill: "#fff",
  opacity: 0.88
});

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  points: "260.41 219.53 252.72 239.21 247.52 236.21 251.9 224.7 235.72 229.39 231.25 226.38 260.41 219.53",
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("polygon", {
  points: "287.74 204.07 280.06 223.75 274.85 220.75 279.23 209.24 263.05 213.93 258.57 210.91 287.74 204.07",
  fill: "#fff"
});

var _ref20 = /*#__PURE__*/React.createElement("polygon", {
  points: "318.16 186.78 310.47 206.47 305.26 203.46 309.64 191.95 293.47 196.65 288.99 193.63 318.16 186.78",
  fill: "#fff"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M124.71,184.07l-1.2-.9L124.57,169l6.24.23s-.32,6.06,1,7.54,5.08.76,5.43.91,2.85-.39,3.87.82-4.05,4.13-6.66,4.54a16.62,16.62,0,0,1-5.35-.18s-.3-3.67-1.21-3.37-1.26,4.13-1.26,4.13Z",
  fill: "#9c4100"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M122.14,139.42c-.52,14.83-1.06,34.16-1.06,34.16s3.39,4.6,12.58,2.64c1-.21,3.18-23.85,4.25-36.15A35.27,35.27,0,0,0,122.14,139.42Z",
  fill: "#efb420"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M141,196.24l-1.2-.9,1.06-14.18,6.24.23s-.32,6.06,1,7.54,5.08.76,5.43.91,2.85-.39,3.87.82-4.05,4.13-6.66,4.54a16.62,16.62,0,0,1-5.35-.18s-.3-3.67-1.21-3.37-1.26,4.13-1.26,4.13Z",
  fill: "#653200"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M143.65,142.12a37.18,37.18,0,0,0-13-3.24c.76,5.55,1.47,9.4,1.59,9.68.3.7,6,35.94,6,35.94C145,187.22,153,185,153,185s-2.75-27.49-3-32.08q0-.74-.08-1.48A10.81,10.81,0,0,0,143.65,142.12Z",
  fill: "#efb420"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M102.2,150.31s11.42-10.34,19.94-10.89,20.62,8.28,19.67,13.4S124.57,169,124.57,169",
  fill: "#efb420"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M125.56,131.85l-9.1-6.43a1.93,1.93,0,0,1-.65-2.37l6.45-14.33a1.93,1.93,0,0,1,2.78-.85l10.17,6.33a1.93,1.93,0,0,1,.69,2.53l-7.52,14.43A1.93,1.93,0,0,1,125.56,131.85Z",
  fill: "#1784aa"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M124.75,131.35l-9.1-6.43a1.93,1.93,0,0,1-.65-2.37l6.45-14.33a1.93,1.93,0,0,1,2.78-.85l10.17,6.33a1.93,1.93,0,0,1,.69,2.53l-7.52,14.43A1.93,1.93,0,0,1,124.75,131.35Z",
  fill: "#29abe2"
});

var _ref28 = /*#__PURE__*/React.createElement("polygon", {
  points: "126.27 130.48 116.03 123.24 122.74 108.31 134.12 115.39 126.27 130.48",
  fill: "#00275e"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M121.53,114.64c-3.38,1.86-8.69,4-12.25,6.43-.57.4-1.42,1.75-.86,1.55-.24.27,2.09,1.19,1.87,1.5-.07.1,1.51-.77,1.59-.73v0a6.1,6.1,0,0,0,4.37.52l.59-.43,0,0,.15-.09a.34.34,0,0,1,.1-.11l.09-.06a.35.35,0,0,1,.13-.21c.79-.62,2.5-.94,2.69-2a2.13,2.13,0,0,0-.25-.78.3.3,0,0,1,.06-.4,2.38,2.38,0,0,0-.35-1.81l0-.05.2-.23a22.91,22.91,0,0,0,2.62-2.14.54.54,0,0,0,.16-.32.45.45,0,0,0,0-.16A.64.64,0,0,0,121.53,114.64Z",
  fill: "#e85454"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M119.8,118.31c-.25-.65-.63-.68-1.21-.43a20.41,20.41,0,0,0-3.38,1.92c-.18.12,0,.41.18.29.66-.45,3.52-2.56,4.1-1.64s-1.34,1.56-1.88,1.85l-2.06,1.09c-.19.1,0,.39.18.29L117,121a.17.17,0,0,0,0,.1,2,2,0,0,0,.39.39,1.26,1.26,0,0,0-.14,1.17l.06.07a3.68,3.68,0,0,1-4.5.65c-.17-.13-.4.11-.23.24,1.34,1,4.11.72,5.05-.77a1.83,1.83,0,0,0,.61-.19,4,4,0,0,0,1.59-1,1.33,1.33,0,0,0,0-1.35l0-.06a.84.84,0,0,0,0-1.2A1.28,1.28,0,0,0,119.8,118.31Zm-.14,3a2.13,2.13,0,0,1-.87.7c-.22.13-.75.5-1,.45-.43-.11-.17-.68,0-.93h0a2.36,2.36,0,0,0,.66-.39l.82-.52.27-.2A1,1,0,0,1,119.66,121.35Zm-1-.63c-.47.29-.85.66-1.29.14.66-.33,1.31-.68,1.94-1.06a1.57,1.57,0,0,0,.48-.44C120.09,120,119,120.51,118.61,120.72Z",
  fill: "#653200"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M111.4,118.51s2.28.51,2.46,5.31l-1.71,4.26-9.31-4.83S105.06,120.46,111.4,118.51Z",
  fill: "#ff9292"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M133.46,120.76c-.69,1.53-1.38,2.92-2,4.49-.43-1-.82-1.89-1.34-2.89a.76.76,0,0,0-.08-.1.8.8,0,0,0-1.48.5,6.51,6.51,0,0,0,1.08,2.64.82.82,0,0,0-.22.16c-1.34,1.49-1,3.77-.86,5.61a.71.71,0,0,0,1.06.57.72.72,0,0,0,.36-.09,6,6,0,0,0,2.43-3.49C133.27,125.8,134.24,123.23,133.46,120.76Z",
  fill: "#e85454"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M98.71,120.64l3.36-1c.83.12,8.11,3.09,11.14,8.28a32.39,32.39,0,0,1,.74,4.81c.28,2.16.5,4.32.61,6.49a47.32,47.32,0,0,1-.11,7.1c-.1,1-.17,1.52-.35,2.52a4.48,4.48,0,0,1-1.32.8c-10.09,3.5-17.5-2.17-17.81-3s-.79-12.46-1-19.38A6.66,6.66,0,0,1,98.71,120.64Z",
  fill: "#ff9292"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M107.62,108.65s2.27,11.4-1.93,12.63-9.14-3.52-9.5-5.87S101.73,104.85,107.62,108.65Z",
  fill: "#e85454"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M106,113.21c.13-.19,2.54-.83,3.05-2.86s-1.34-4.71-5.53-5.09-11.25,1.91-10.17,13,12.22,6.31,12.95,2.77A21.18,21.18,0,0,0,106,113.21Z",
  fill: "#653200"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M106,113.21s.71,3.78,2.24,5.4,2.77,4.58.89,6.84,0,3.48,2.65,5.64,1,10.93-8.56,8.78-14.09-7.93-14.09-7.93,2.46-17.23,5.07-21.27",
  fill: "#653200"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M113.24,128.08s2.17,7.27,4.34,7.49,5.45-3,7.77-7.17a6.08,6.08,0,0,1,6.66,5.83s-7.64,15.47-18.76,11.69",
  fill: "#ff9292"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M73.27,183.48c-6.84-8.53-10-19.44-9.84-30.36a34.59,34.59,0,0,1,9.67-23.7c5.64-5.79,14.16-8.64,21.72-4.72,6.27,3.26,9.31,9.5,11.49,15.9,2.62,7.66,3.5,17.49,12.84,19.86,3.62.92,7.43.29,11.16,0,6.51-.44,13.36,1.67,15.38,8.6,3.62,12.41-13.06,23-22.45,27-16.33,7-36,2.56-48-10.4Q74.18,184.62,73.27,183.48Z",
  fill: "#e1a621"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M145.37,169.25c-6.63,12-28.25,17.42-40,16.82-10.7-.55-17.45-7.08-16.72-17.9.4-5.94,2.29-11.87,1.76-17.85-.9-10.2-10.59-18.56-20.47-16.58a34.88,34.88,0,0,0-6.61,20.07c-.14,10.92,3,21.83,9.84,30.36q.91,1.14,1.92,2.22c12,13,31.72,17.37,48,10.4,9.39-4,26.07-14.59,22.45-27C145.5,169.6,145.43,169.43,145.37,169.25Z",
  fill: "#00275e",
  opacity: 0.36
});

var _ref40 = /*#__PURE__*/React.createElement("polygon", {
  points: "234.98 234 227.3 253.68 222.09 250.68 226.47 239.17 210.29 243.87 205.82 240.85 234.98 234",
  fill: "#fff"
});

var _ref41 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 157.19,
  cy: 222.94,
  rx: 5.55,
  ry: 2.65,
  fill: "#fff"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M195,87.59l-11.59,7s-2.32.42-2.81-1.69-5.2-4.64-8.57-2.74-.28,4.57,3.3,5,3.3,1.26,2.53,2.18-10.4,6.39-10.4,6.39L179,110.64s2.11.84,1.26,2-3.23-1.62-5.83,1.05,2.67,5.06,5.83,4.64,3.37-1.69,3.37-2.67.91-1.41,1.83-1,13.91,7.52,13.91,7.52l10.82-6.53s-4.92.28-6.89-2.25-1.41-5.34,2.39-5.76,9.06,1.33,8.92,5.06l11.87-6.39-13.63-7.94s-2,5.83-9.2,4.29-4.27-6.72,5-7Z",
  fill: "#e1a621"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M170.54,84.71V92s1.35,1.68,4.45,1.36,4.37-4.73,4.37-4.73",
  fill: "#e1a621"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M167.43,96.48v7.27l6.79,3.3-.47,1.2,0,7s3.55.81,5.31,0,2.52-3.49,4.33-3.67,19.94,5.31,19.94,5.31l6.87-1.3v-7.27s-9.2,4.36-12.39.08",
  fill: "#e1a621"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M226.45,106.28V99l-17.83-3.38V88.36s-5.8-.14-5.88-.11-7.95,2-4.32,6.66-2.2,8.87,3,9.71",
  fill: "#e1a621"
});

var _ref46 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.36
}, /*#__PURE__*/React.createElement("path", {
  d: "M195,87.59l-11.59,7s-2.32.42-2.81-1.69-5.2-4.64-8.57-2.74-.28,4.57,3.3,5,3.3,1.26,2.53,2.18-10.4,6.39-10.4,6.39L179,110.64s2.11.84,1.26,2-3.23-1.62-5.83,1.05,2.67,5.06,5.83,4.64,3.37-1.69,3.37-2.67.91-1.41,1.83-1,13.91,7.52,13.91,7.52l10.82-6.53s-4.92.28-6.89-2.25-1.41-5.34,2.39-5.76,9.06,1.33,8.92,5.06l11.87-6.39-13.63-7.94s-2,5.83-9.2,4.29-4.27-6.72,5-7Z",
  fill: "#00275e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.54,84.71V92s1.35,1.68,4.45,1.36,4.37-4.73,4.37-4.73",
  fill: "#00275e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.43,96.48v7.27l6.79,3.3-.47,1.2,0,7s3.55.81,5.31,0,2.52-3.49,4.33-3.67,19.94,5.31,19.94,5.31l6.87-1.3v-7.27s-9.2,4.36-12.39.08",
  fill: "#00275e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M226.45,106.28V99l-17.83-3.38V88.36s-5.8-.14-5.88-.11-7.95,2-4.32,6.66-2.2,8.87,3,9.71",
  fill: "#00275e"
}));

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M195,80.32l-11.59,7s-2.32.42-2.81-1.69S175.37,81,172,82.92s-.28,4.57,3.3,5,3.3,1.26,2.53,2.18-10.4,6.39-10.4,6.39l11.52,6.89s2.11.84,1.26,2-3.23-1.62-5.83,1.05,2.67,5.06,5.83,4.64,3.37-1.69,3.37-2.67.91-1.41,1.83-1,13.91,7.52,13.91,7.52l10.82-6.53s-4.92.28-6.89-2.25-1.41-5.34,2.39-5.76,9.06,1.33,8.92,5.06L226.45,99l-13.63-7.94s-2,5.83-9.2,4.29-4.27-6.72,5-7Z",
  fill: "#e1a621"
});

var SvgCompany = function SvgCompany(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 300",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _ref4, /*#__PURE__*/React.createElement("g", {
    opacity: 0.63,
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref5), /*#__PURE__*/React.createElement("path", {
    d: "M280.21,156.31l-2.63,3.86L234.13,183l15.94,16.73,48.21-33.35C295.78,161.82,284.08,159.89,280.21,156.31Z",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.3,223.75l48.89-30.82L89,154.5,40.89,184.9C44.6,186.71,104.5,222.18,108.3,223.75Z",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompany, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/company.5e0befb3.svg";
export { ForwardRef as ReactComponent };